import styled from 'styled-components';

export const LicensesWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background-color: #333333;

  #LicensesTitle {
    font-size: 30px;
    background-color: #333333;
    margin: 0px;
    padding: 10px;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    text-align: center;
    z-index: 35;
  }
`;

export default LicensesWrapper;